module.exports = __webpack_public_path__ + "img/spear-hades.43525514.jpg";